import { cn } from '../../utils';

export interface ReceiptDividerProps {
  /** Additional class name */
  className?: string;
}

/**
 * ReceiptDivider - Perforated line divider for receipt
 *
 * Creates a dashed line effect resembling perforation on a printed receipt
 */
export function ReceiptDivider({ className }: ReceiptDividerProps) {
  return (
    <div
      className={cn('w-full my-sm', className)}
      style={{
        height: '1px',
        backgroundImage: `linear-gradient(to right, #cbd5e1 50%, transparent 50%)`,
        backgroundSize: '8px 1px',
        backgroundPosition: '0 0',
        backgroundRepeat: 'repeat-x'
      }}
      aria-hidden
    />
  );
}
